<template>
    <section>

    </section>
  </template>
  
  <script>
  import store from './status'
  
  String.prototype.toHHMMSS = function () {
    var sec_num = parseInt(this, 10); // don't forget the second param
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = sec_num - (hours * 3600) - (minutes * 60);
  
    if (hours < 10) { hours = "0" + hours; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }
    return hours + ':' + minutes + ':' + seconds;
  }
  
  String.prototype.toSeconds = function () {
    if (!this.match(/\d{2}:\d{2}:\d{2}/g)) return 'Bad foramt';
    let hhmmss = this.split(':');
  
    let hour = Math.floor(parseInt(hhmmss[0]) * 3600);
    let minutes = Math.floor(parseInt(hhmmss[1]) * 60);
    let seconds = parseInt(hhmmss[2]);
  
    return hour + minutes + seconds;
  }
  
  export default {
    props: ['nome', 'extension', 'status', 'connection'],
    data: function () {
      return {
        intervalTimer: {},
        ramal: user.getExtension(),
        userStatus: this.status,
        open: false,
        oldStatus: '',
        oldTimer: '00:00:00',
        call: {
          time: '00:00:00',
          channel: '',
          num: '',
          oldNum: '',
          type: '',
        },
        queues: [],
        extensionStatus: false
      }
    },
    watch: {
      userStatus: function () {
        store.setStatus(this.extension, this.userStatus);
      },
    },
    methods: {
      stopTimer() {
        clearInterval(this.intervalTimer);
        if (this.oldStatus == "pausa") {
          this.call.num = this.call.oldNum;
          this.userStatus = this.oldStatus;
          this.oldStatus = "ativo";
          this.calcTimer(this.oldTimer);
          return;
        }

        this.userStatus = this.oldStatus;
        this.call.time = "00:00:00";
        this.call.num = '';
        this.call.type = '';
      },
      calcTimer(time) {
        clearInterval(this.intervalTimer);
        let tempo = time.toSeconds();
        this.intervalTimer = setInterval(() => {
          this.call.time = tempo.toString().toHHMMSS();
          tempo++;
        }, 1000);
      },
      queuemember: async function () {
        this.connection.on(`QueueMember-${this.extension}`, (data) => {
          if (this.userStatus == 'pausa') return;
          if (this.userStatus == 'ligacao') return;

          this.extensionStatus = (data.Status == '4' || data.Status == '5') ? false : true;
          this.oldStatus = 'ativo';

          if (data.Paused == '1') {
            this.call.num = data.PausedReason;
            this.call.oldNum = this.call.num;
            this.userStatus = 'pausa';
            this.oldStatus = 'ativo';
            this.oldTimer = data.LastPause.toHHMMSS();
            this.calcTimer(data.LastPause.toHHMMSS());
            return;
          }

          this.userStatus = 'ativo';
          this.oldStatus = this.userStatus;
        });
      },
      coreshowchannel: async function () {
        this.connection.on(`CoreShowChannel-${this.extension}`, (data) => {
          if (this.userStatus == 'pausa') {
            this.call.oldNum = this.call.num;
          }
  
          this.userStatus = 'ligacao'; //Alteração do status do card para Ligação
  
          if (data.type.includes('entrante')) {
            this.call.type = 'entrante';
          } else if (data.type.includes('sainte')) {
            this.call.type = 'sainte';
          } else if (data.type.includes('transfer')) {
            this.call.type = 'transfer';
          } else {
            this.call.type = '';
          }
  
          if (data.status == 'ringing') {
            this.call.num = `Tocando ${data.phone}`;
          } else {
            this.call.num = data.phone;
          }
  
          this.call.channel = data.channel;
          this.calcTimer(data.duration);
          return;
        });
      },
      queuememberadded: async function () {
        this.connection.on(`QueueMemberAdded-${this.extension}`, data => {
          this.userStatus = 'ativo';
          this.oldStatus = this.userStatus;
          this.call.type = '';
        });
      },
      queuememberremoved: async function () {
        this.connection.on(`QueueMemberRemoved-${this.extension}`, data => {
          this.userStatus = 'deslogado';
          this.oldStatus = this.userStatus;
          this.call.type = '';
        });
      },
      queuememberpause: async function () {
        this.connection.on(`QueueMemberPause-${this.extension}`, data => {
          if (this.userStatus == 'ligacao') {
            if (this.oldStatus == 'pausa') {
              this.oldStatus = 'ativo';
            } else {
              this.oldStatus = 'pausa';
              this.oldTimer = '00:00:00';
            }
            return;
          }

          //Pausa
          if (data.Paused == 1) {
            this.oldStatus = 'pausa';
            this.oldTimer = '00:00:00';
            this.call.oldNum = data.PausedReason ? data.PausedReason : data.Reason;
            this.stopTimer();
            return;
          }

          //Ativo
          this.oldStatus = 'pausa';
          this.userStatus = 'ativo';
          this.call.num = '';

          clearInterval(this.intervalTimer);
          this.call.time = '00:00:00';
          this.call.type = '';

          return;
        });
      },
      newconnectedline: async function () {
        this.connection.on(`NewConnectedLine-${this.extension}`, data => {
          if (this.userStatus == 'pausa') {
            this.call.oldNum = this.call.num;
          }
  
          this.userStatus = 'ligacao'; //Alteração do status do card para Ligação
  
          if (data.type.includes('entrante') || data.type.includes('tocando')) {
            this.call.type = 'entrante';
          } else if (data.type.includes('sainte')) {
            this.call.type = 'sainte';
          } else if (data.type.includes('transfer')) {
            this.call.type = 'transfer';
          } else {
            this.call.type = '';
          }
  
          if (data.status == 'ringing') {
            this.call.num = `Tocando ${data.phone}`;
          } else {
            this.call.num = data.phone;
          }
  
          this.call.channel = data.channel;
          this.calcTimer('00:00:00');
  
          return;
        });
      },
      peerStatus: async function () {
        this.connection.on(`PeerStatus-${this.extension}`, data => {
          this.extensionStatus = (data == 'Registered' || data == 'Reachable') ? true : false;
          if (data != 'Registered' && this.userStatus == "ligacao") this.userStatus = this.oldStatus;
        });
      },
      hangup: async function () {
        this.connection.on(`Hangup-${this.extension}`, data => {
          this.stopTimer();
        });
      }
    },
    mounted() {
      this.userStatus = !this.userStatus ? "ativo" : "deslogado";
      this.oldStatus = this.userStatus;
  
      this.queuemember();
      this.coreshowchannel();
  
      this.queuememberadded();
      this.queuememberremoved();
  
      this.queuememberpause();
      this.newconnectedline();
  
      this.peerStatus();
  
      this.hangup();
    },
  }
  </script>